import { useAuthStore } from '@shared/stores/authStore';
import { useDocumentTitle } from '@shared/hooks/useDocumentTitle';
import { Navigate, Outlet } from 'react-router-dom';

interface GuestGuardProps {
    redirectPath?: string;
}

const GuestGuard = ({ redirectPath = '/' }: GuestGuardProps): JSX.Element => {
    const token = useAuthStore((state) => state.token);
    useDocumentTitle(); // Actualizar título del documento para rutas guest

    if (token) {
        return <Navigate to={redirectPath} replace />;
    }

    return <Outlet />;
};

export default GuestGuard;

